// pages/MetasComissao.tsx
import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { MetaComissaoMensal } from '../types/entities';
import { MetaComissaoTable } from '../components/meta-comissao/MetaComissaoTable';
import { MetaComissaoModal } from '../components/meta-comissao/MetaComissaoModal';

export const MetasComissao: React.FC = () => {
  const [selectedMeta, setSelectedMeta] = useState<MetaComissaoMensal | undefined>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Handlers
  const handleNewMeta = () => {
    setSelectedMeta(undefined);
    setIsEditing(false);
    setIsModalOpen(true);
  };

  const handleEditMeta = (meta: MetaComissaoMensal) => {
    setSelectedMeta(meta);
    setIsEditing(true);
    setIsModalOpen(true);
  };

  const handleViewMeta = (meta: MetaComissaoMensal) => {
    setSelectedMeta(meta);
    setIsEditing(false);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMeta(undefined);
    setIsEditing(false);
  };

  const handleSaveMeta = (meta: MetaComissaoMensal) => {
    // Trigger table refresh
    setRefreshTrigger(prev => prev + 1);
    console.log('Meta salva:', meta);
  };

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleDeleteMeta = (meta: MetaComissaoMensal) => {
    // Delete is handled by the table component
    console.log('Meta deletada:', meta);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Metas de Comissão
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Gerencie as metas mensais de comissão e acompanhe o desempenho por produto
              </p>
            </div>

            <button
              onClick={handleNewMeta}
              className="px-3 py-1.5 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Nova Meta
            </button>
          </div>
          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            {/* Stats cards removed as requested */}

            {/* Quick Actions removed; primary action moved to header */}

            {/* Table */}
            <MetaComissaoTable
              onEdit={handleEditMeta}
              onView={handleViewMeta}
              onRefresh={handleRefresh}
              onDelete={handleDeleteMeta}
              refreshTrigger={refreshTrigger}
            />
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>

      {/* Modal */}
      <MetaComissaoModal
        meta={selectedMeta}
        isOpen={isModalOpen}
        isEditing={isEditing}
        onClose={handleCloseModal}
        onSave={handleSaveMeta}
      />
    </div>
  );
};